import { mdiBookmark } from "@mdi/js";
import { For, Show } from "solid-js";
import { Buis } from "~/components/Buis";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion";
import { Card } from "~/components/ui/card";
import { Icon } from "~/components/ui/icon";
import { Spacer } from "~/components/ui/spacer";
import { cn } from "~/util/utils";
import { useDocumentContext } from "../../../providers/context";
import type { DocumentTocChildProps } from "./index";

export function DocumentTocDesktop(props: DocumentTocChildProps) {
	const { sections, selected, setSelected, isBookmarked } = useDocumentContext();

	return (
		<Accordion
			multiple={false}
			collapsible
			value={props.accordion}
			onChange={props.setAccordion}
		>
			<For each={sections()}>
				{(section) => (
					<Card class="mb-4 border-gray-200">
						<AccordionItem
							class="border-b-0"
							value={section.heading.id}
						>
							<AccordionTrigger
								class={cn(
									"text-left",
									section.heading.id === props.accordion[0]
										? `border ${section.heading.headingColor ? "bg-[var(--bg-color)] hover:bg-[var(--bg-color)]" : ""}`
										: "border-none",
								)}
								style={{
									"--bg-color": section.heading.headingColor,
								}}
								variant={section.heading.id === props.accordion[0] ? "accent" : "gray"}
							>
								<Buis value={section.heading.tocTitle} />
							</AccordionTrigger>
							<AccordionContent>
								<div>
									<For each={section.articles}>
										{(article, index) => (
											<div
												class={cn(
													"p-3 flex relative hover:bg-gray-100 hover:rounded-sm transition-all",
													index() !== section.articles.length - 1 &&
														"border-b border-gray-200",
													article.isViewable && "cursor-pointer",
												)}
												onClick={article.isViewable ? () => setSelected(article) : undefined}
											>
												<div
													class={cn(
														"absolute top-2 bottom-2 left-2 w-1 rounded-md transition-all",
														article.id === selected()?.id ? "block" : "hidden",
													)}
													style={{
														"background-color":
															article.headingColor ||
															section.heading.headingColor ||
															"hsl(var(--accent))",
													}}
												/>
												<div>
													<Buis
														class="pl-2 mb-1 text-sm"
														value={article.tocSubtitle}
													/>
													<Buis
														class="pl-2"
														value={article.tocTitle}
													/>
												</div>
												<Spacer />
												<Show when={isBookmarked(article)}>
													<Icon
														path={mdiBookmark}
														class="fill-accent my-auto"
													/>
												</Show>
											</div>
										)}
									</For>
								</div>
							</AccordionContent>
						</AccordionItem>
					</Card>
				)}
			</For>
		</Accordion>
	);
}
